import React, { useState, useEffect } from "react";
import Header from "../Components/PurchaseOrderReport/Header";
import PurchaseOrderOverview from "../Components/PurchaseOrderReport/PurchaseOrderOverview";
import { getPurchaseOrderReport } from "../actions/PurchaseOrderReportAction";
import NewEntrySection from "../Components/PurchaseOrderReport/NewEntrySection";
import { getPurchaseOrderReports } from "../services/purchaseOrderService";
import { getDistributorNames } from "../Common/functions";

const PurchaseOrderReport = ({ userRole, user }) => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [addNewSection, setAddNewSection] = useState(false);
  const [filters, setFilters] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);

  function getTotalPages(totalItems, itemsPerPage) {
    if (itemsPerPage <= 0) return 0;
    return Math.ceil(totalItems / itemsPerPage);
  }

  const getApplicationReport1 = async () => {
    setData([]);
    setLoading(true);

    let distributorName;
    
    if (userRole === "super_admin") {
      distributorName = filters.distributorName;
    } else if (userRole === "manager") {
      distributorName =
        !filters.distributorName || filters.distributorName.trim() === ""
          ? getDistributorNames()
          : filters.distributorName;
    } else {
      distributorName = getDistributorNames();
    }

    try {
      const payload = {
        category: "Sales Order",
        page_size: itemsPerPage,
        page_number: currentPage,
        start_date: filters.fromDate,
        end_date: filters.toDate,
        search_term: searchTerm,
        distributor_name:distributorName,
      }
      // Remove null, undefined, and empty string values
      const cleanedPayload = Object.fromEntries(
        Object.entries(payload).filter(([key, value]) => {
          return value !== null && 
                value !== undefined && 
                value !== "" && 
                value !== " ".trim(); // Also removes whitespace-only strings
        })
      );
      const result = await getPurchaseOrderReports(cleanedPayload);

      if (result?.data) {
        setData(result.data.items);
        setCurrentPage(result.data.current_page);
        setTotalCount(result.data.total_records);
        setTotalPages(getTotalPages(result.data.total_records, itemsPerPage));
      } else {
        console.error("Unexpected response format:", result);
      }
    } catch (error) {
      console.error("Error fetching purchase order reports:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (currentPage !== 1) {
      setCurrentPage(1);
    } else {
      getApplicationReport1();
    }
  }, [searchTerm]);

  useEffect(() => {
    getApplicationReport1();
  }, [itemsPerPage, currentPage, filters]);

  return (
    <div className="mt-4">
      {addNewSection ? (
        <>
          <NewEntrySection
            handleBack={() => setAddNewSection(false)}
            user={user}
            userRole={userRole}
          />
        </>
      ) : (
        <>
          <Header
            ButtonVisibility={
              userRole === "distributor_admin" || userRole === "super_admin"
            }
            userRole={userRole}
            StatsVisibility={userRole !== "distributor_admin"}
            setAddNewSection={setAddNewSection}
          />
          <PurchaseOrderOverview
            data={data}
            loading={loading}
            currentPage={currentPage}
            totalPages={totalPages}
            totalCount={totalCount}
            setCurrentPage={setCurrentPage}
            userRole={userRole}
            setSearchTerm={setSearchTerm}
            setFilters={setFilters}
            setItemsPerPage={setItemsPerPage}
            itemsPerPage={itemsPerPage}
            filters={filters}
          />
        </>
      )}
    </div>
  );
};

export default PurchaseOrderReport;
